import axios from "axios";
import React, { useState, useRef, useMemo, useEffect } from "react";
import {
  Container,
  CircularProgress,
  Button,
  Box,
  Typography,
  Grid
} from "@mui/material";
import { Formik, Form } from "formik";
import { InfoOutlined } from "@mui/icons-material";
import {pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "../../utils/css/infromationRequired.css";
import loggingService from "../../../services/logging.service";
import { FileUploader, isSafeFilename, checkHarmfulPdfContent } from "../../utils/fileUploader";
import BillDetails from "../claimForms/billDetailsPage";
import UploadedFilesPreview from "./UploadedFilesPreview";
import FilePreviewDialog from "./FilePreviewDialog";
import {
  generateValidationSchema,
  hasOptionalField,
  LocalStorageKeys,
  pageConfigurationCarouselIDs,
  pageConfigurationPageIDs,
  HEALTH_CHECK,
  DEPENDENTS_PREVENTIVE_HEALTH_CHECK_UP,
  VACCINATION,
  VACCINATION_LABEL,
  VACCINATION_CONTRACT,
  SELF,
  USERS,
  ERROR_MAPPING_PATIENT_NAME_TO_RELATION
} from "../../utils/constants/constants";
import billDetailsFormConstants from "../../utils/constants/billDetailsFormConstants.json";
import { dateConverter, TIMEZONES } from "../../../utils/dateUtils";
import { getBillCategories, sleep,handleBannerClick } from "../../utils/miscutils";
import Select from "../../customFiles/Select";
import { trackEvent } from "../../../config/eventHandlers";
import { ScreenName, DocumentType, PRESCRIPTION_QUESTION_ENTITY_ID_LIST } from "../../../config/constants";
import { isFieldRequired as isFieldRequiredUtil, PRESCRIBED_PHARMACY_CONTRACT, PHARMACY_CONTRACT } from "../../utils/constants/constants";
import UploadIcons from "../../utils/images/upload2.svg";
import eyeIcon from "../../utils/images/eye.svg";
import Carousel from "../../customFiles/Carousel";
import { isMobile } from "../../utils/miscutils";
import { isWebView } from "../../utils/deviceUtils";
import { useTaskDeviceBridge } from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import _ from "lodash";
import { getRedirectToken } from "../../../utils/cookieUtils";  
import axiosInstance from "../../../utils/axiosInterceptor"; 
import { EMERGENCY_PATHOLOGY_CONTRACT } from "../../utils/constants/constants";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function BillDetailsPopUp(props) {
  const [billError, setBillError] = useState("");
  let apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL;
  const [billTypeMapping, setBillTypeMapping] = useState([]);
  const [oldDocuments, setOldDocuments] = useState({});
  const [existingAllDocuments, setExistingAllDocuments] = useState({});

  let docTypeError = {};
  let documentSize = 0;
  let previousSize = 0;
  const taskDeviceBridge = useTaskDeviceBridge();
  const formRef = useRef(null);
  const fileInputRefs = useRef({});
  const focusOnErrorRef = useRef();
  const [apiFailure, setApiFailure] = useState();
  const [files, setFiles] = useState({});
  const [billDocuments, setBillDocuments] = useState({});
  const [uploadedBillDocuments, setUploadBillDocuments] = useState({});
  const [documentErrorMessage, setErrorMessage] = useState({});
  const [temp, setTemp] = useState(false);
  const [billType, setBillType] = useState(props.billDetails.category);
  // TODO: Refactor entire claims system. Temporary solution. 
  // const [billRules, setBillRules] = useState(null);
  const [billDates, setBillDates] = useState(null);
  const [isUploading, setIsUploading] = useState({});
   const [previewModal, setPreviewModal] = useState({
    open: false,
    url: null,
    isPdf: false,
    name: "",
    fileObject: null,
  });
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [billsObjFileObjects, setBillsObjFileObjects] = useState({});
 const token = getRedirectToken();
  const utm_source = localStorage.getItem("source")
    ? localStorage.getItem("source")
    : "web";
  const selectedPolicy =
      JSON.parse(localStorage.getItem("selectedPolicy")) || {};

  
const resolvedEntityId = props?.entityId ?? selectedPolicy?.entityId;
if (resolvedEntityId) {
  localStorage.setItem(
    LocalStorageKeys.CURRENT_PM_ENTITY_ID,
    String(resolvedEntityId)
  );
}

useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'instant' });
}, []);

 const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const getContractIdForCategory = (categoryName) => {
    try {
    
      const categoriesV2 = JSON.parse(localStorage.getItem("categoriesV2") || "[]");
      
      const category = Array.isArray(categoriesV2)
        ? categoriesV2.find(cat => cat.category === categoryName)
        : categoriesV2[categoryName];
      
      const contractId = category?.contractid || null;
      if (!contractId) {
        console.warn(`⚠️ No contract ID found for category: ${categoryName}`);
      }
      
      return contractId;
    } catch (error) {
      console.error("❌ Error getting contract ID:", error);
      return null;
    }
  };
  useEffect(() => {
    initializeFromProps();
  }, [props.documentDetails, props.billFileTypes]);

  const initializeFromProps = () => {
    let newBillTypeMapping = [];
    let newOldDocuments = {};
    let newExistingAllDocuments = {};

    if (props.documentDetails && props.documentDetails.length > 0) {
      for (const index in props.documentDetails) {
        var name;
        if (!newBillTypeMapping.includes(props.documentDetails[index].filetype)) {
          newBillTypeMapping.push(props.documentDetails[index].filetype);
          name = "old" + props.documentDetails[index].filetype;
          newOldDocuments[name] = [];
          newExistingAllDocuments[props.documentDetails[index].filetype] = [];
        }
        let tempArr = [
          ...newOldDocuments[name],
          props.documentDetails[index].documenturl,
        ];
        newOldDocuments[name] = tempArr;
        let tempArr1 = [
          ...newExistingAllDocuments[props.documentDetails[index].filetype],
          props.documentDetails[index].claimDocURL,
        ];
        newExistingAllDocuments[props.documentDetails[index].filetype] = tempArr1;
      }
    } else {
      newBillTypeMapping = props.billFileTypes || [];
    }

    setBillTypeMapping(newBillTypeMapping);
    setOldDocuments(newOldDocuments);
    setExistingAllDocuments(newExistingAllDocuments);

    initializeDocumentTypes(newBillTypeMapping);
  };

  const initializeDocumentTypes = (mapping) => {
    let newDocType = {};
    let newDocTypeName = {};
    let newDocTypeError = {};
    let newUploadedDocName = {};
    let newIsUploading = {};
    for (const value of mapping) {
      newDocType[value] = [];
      newDocTypeName[value] = [];
      newDocTypeError[value] = [];
      newUploadedDocName[value] = [];
      newIsUploading[value] = 0;
    }
    setBillDocuments(newDocType);
    setFiles(newDocTypeName);
    setErrorMessage(newDocTypeError);
    setUploadBillDocuments(newUploadedDocName);
    setIsUploading(newIsUploading);
  };

  useEffect(() => {
    if (props.billDetails.claimid) {
      getDateLimits();
    }
  }, [props.billDetails.claimid])

  useEffect(() => {
    if (billType) {
      filesToBeUploadedBasedOnBillType(billType);
    }
  }, [billType]);

  let billDocs = billDocuments;
  let billDocName = files;
  let uploadedDocs = uploadedBillDocuments;

 

 

  const submitBillDetails = async () => {
    props.closeHandler();
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const uploadClaimDocsToS3 = async (documents, name) => {
    let uploadClaimDocResponse;
    let claimID = props.billDetails.claimid;
    uploadedDocs = uploadedBillDocuments;
    let formdata = new FormData();
    let uploadResponse;
    let tempObjFileObjects = { ...billsObjFileObjects };
    if (!tempObjFileObjects[name]) {
      tempObjFileObjects[name] = [];
    }
    for (var i = 0; i < documents.length; ++i) {
      let singleFormdata = new FormData();
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = today.getFullYear();
      var date = new Date();
      var hour = date.getHours();
      var min = date.getMinutes();
      var sec = date.getSeconds();
      var milli = date.getMilliseconds();
      today =
        yyyy +
        "_" +
        mm +
        "_" +
        dd +
        "_" +
        hour +
        "_" +
        min +
        "_" +
        sec +
        "_" +
        milli;
      var billDocname = documents[i].name.split(".");
      formdata.append(
        "files[]",
        documents[i],
        "PAT" +
          "_" +
          props.empId +
          "_" +
          claimID +
          "_" +
          i.toString() +
          "_" +
          today +
          "." +
          billDocname[billDocname.length - 1]
      );
      singleFormdata.append(
        "files[]",
        documents[i],
        "PAT" +
          "_" +
          props.empId +
          "_" +
          claimID +
          "_" +
          i.toString() +
          "_" +
          today +
          "." +
          billDocname[billDocname.length - 1]
      );
      let fileName =
        "PAT" +
        "_" +
        props.empId +
        "_" +
        claimID +
        "_" +
        i.toString() +
        "_" +
        today +
        "." +
        billDocname[billDocname.length - 1];
      let fileType = "ClaimDocuments";
      let imageType = `image/${fileName.split(".").pop()}`;
      let singleFiledata = new File([documents[i]], fileName, {
        type: imageType,
      });

      try {
        const fileUploadResponse = await FileUploader.uploadFileData(
          props?.entityId,
          singleFiledata,
          fileType
        );

        let respStoreObj = {
          Bucket: "reimbursement-claims-docs",
          Key: fileUploadResponse.fileName,
          key: fileUploadResponse.fileName,
          ServerSideEncryption: "AES256",
          Location: `https://reimbursement-claims-docs.s3.ap-south-1.amazonaws.com/${fileUploadResponse.fileName}`,
        };

        uploadClaimDocResponse = fileUploadResponse.isSuccess
          ? "success"
          : "failure";
        uploadedDocs[name].push(respStoreObj);
        tempObjFileObjects[name].push(documents[i]);
      } catch (error) {
        loggingService.log({
          level: "ERROR",
          method: "POST/PUT",
          message: `Error in uplodaing File :  ${error.message}`,
          error: error,
        });
        uploadClaimDocResponse = "failure";
        break;
      }
    }
    if (uploadClaimDocResponse === "success") {
      setUploadBillDocuments(JSON.parse(JSON.stringify(uploadedDocs)));
      setBillsObjFileObjects(tempObjFileObjects);
    }

    return uploadClaimDocResponse;
  };

  const updateBillDetails = async (values) => {
    const contractId = getContractIdForCategory(values.category);

    const validationSchema = generateValidationSchema(
      values.category, 
      billDetailsFormConstants
    );
    try {
      await validationSchema.validate(values);
    } catch (error) {
      const errorMsg = error.toString().split(":")[1].trim();
      setBillError(errorMsg);
      return false;
    }
    let isUpdated = values.category !== props.billDetails.category || values.billNumber !== props.billDetails.billnumber ? 0 : 1;
    let isclaimamountupdateflag =
      values.billAmount === props.billDetails.billamount ? 0 : 1;
    let internalFiles = {};
    let addBillResponse;
    for (var i = 0; i < billTypeMapping.length; ++i) {
      var name = "old" + billTypeMapping[i];

      internalFiles[name] = oldDocuments[name];
      let tempName = [];
      for (
        var j = 0;
        j < uploadedBillDocuments[billTypeMapping[i]].length;
        ++j
      ) {
        if (
          uploadedBillDocuments[billTypeMapping[i]][j].Key ||
          uploadedBillDocuments[billTypeMapping[i]][j].key
        ) {
          tempName.push(
            uploadedBillDocuments[billTypeMapping[i]][j].Key
              ? uploadedBillDocuments[billTypeMapping[i]][j].Key
              : uploadedBillDocuments[billTypeMapping[i]][j].key
          );
        } else return false;
      }
      internalFiles[billTypeMapping[i]] = tempName;
    }
    const billDetailsBody = [];
    const cleanedValues = { ...values };
    Object.keys(cleanedValues).forEach(field => {
      const coreFields = ['category', 'billNumber', 'billDate', 'billAmount'];
      if (coreFields.includes(field)) {
        return;
      }
      const isFieldRequired = billDetailsFormConstants.contractBasedFields[field] && billDetailsFormConstants.contractBasedFields[field].includes(values.category);
      if (!isFieldRequired) {
        delete cleanedValues[field];
      }

      if (field.startsWith("other") && field !== "otherCenterName") {
        const baseField = field.replace("other", '').charAt(0).toLowerCase() + field.replace('other', '').slice(1);
        if (!cleanedValues[baseField]) {
          delete cleanedValues[field];
        }
      }
    })
    
    const json = {
      hospitalname: cleanedValues.centerName
        ? cleanedValues.centerName === "others"
          ? cleanedValues.otherCenterName
          : cleanedValues.centerName
        : "",
      billdate: dateConverter(cleanedValues.billDate, TIMEZONES.UTC, "default"),
      billamount: cleanedValues.billAmount,
      category: cleanedValues.category,
      contractid: contractId, 
      billnumber: cleanedValues.billNumber,
      claimid: props.billDetails.claimid,
      entityid: props.entityId,
      grade: "",
      isirflow: 1,
      isupdateflag: isUpdated,
      oldbillnumber: props.billDetails.billnumber,
      oldbillcategory: props.billDetails.category,
      oldbillid: props.billDetails.id,
      isclaimamountupdateflag: isclaimamountupdateflag,
      files: internalFiles,
      assetDetails: {
        pincode: cleanedValues.pincode,
        address: cleanedValues.centerAddress || "",
        category: cleanedValues.category || "",
        isfavourite:
          cleanedValues.favDoctorName || cleanedValues.favCenterName ? true : false,
        outofnetwork:
          cleanedValues.centerName && cleanedValues.centerName === "others" ? true : false,
        speciality: cleanedValues.doctorSpeciality,
        doctorid: cleanedValues.doctorRegisteredNumber || "",
        doctorname: cleanedValues.doctorName || "",
        hospitalid: "",
        hospitalname: cleanedValues.centerName
          ? cleanedValues.centerName === "others"
            ? cleanedValues.otherCenterName
            : cleanedValues.centerName
          : "",
        labid: "",
        labname: cleanedValues.centerName
          ? cleanedValues.centerName === "others"
            ? cleanedValues.otherCenterName
            : cleanedValues.centerName
          : "",
        contactinfo: "",
        additionals: {
          ...(!cleanedValues?.illnessType
            ? {}
            : {
                illnessType:
                  cleanedValues?.illnessType === "others"
                    ? cleanedValues?.otherIllnessType
                    : cleanedValues?.illnessType,
              }),
          ...(!cleanedValues?.treatmentType
            ? {}
            : {
                treatmentType:
                  cleanedValues?.treatmentType === "others"
                    ? cleanedValues?.otherTreatmentType
                    : cleanedValues?.treatmentType,
              }),
          ...(!cleanedValues?.hasPrescription
            ? {}
            : {
                hasPrescription: cleanedValues?.hasPrescription,
              }),
          ...(!cleanedValues?.prescriptionReason
            ? {}
            : {
                prescriptionReason: cleanedValues?.prescriptionReason,
              }),
        },
      },
    };
    billDetailsBody.push(json);
    try {
      // change the endpoint back to updateBillDetails later
      const response = await axiosInstance.post(
        `${apiUrl}/auth/addBillDetails`,
        billDetailsBody,
        {
          headers: {
            authtoken: props.accessToken,
          },
        }
      );
      if (response.data.isSuccess) addBillResponse = "success";
      else addBillResponse = "failure";
    } catch (error) {
      console.error("❌ [BillDetailsPopUp] API Error:", error);
      if (error.response.data.message === "Token_Expired")
        addBillResponse = "Token_Expired";
      else addBillResponse = "failure";
    }
    return addBillResponse;
  };

  const getDateLimits = async () => {
    if (!props.billDetails.claimid) {
      setBillDates(null);
      return;
    };
    const config = {
      params: { claimid: props.billDetails.claimid },
      headers: {
        authtoken: props.accessToken,
      },
    }
    try {
      const response = await axiosInstance.get(`${apiUrl}/admin/ir-flow-bill-dates`, config);
      const { message = "", ...respDates } = response.data;
      if (!_.isEmpty(respDates)) {
        const { minBillDate, maxBillDate } = respDates;
        setBillDates({ minDate: minBillDate, maxDate: maxBillDate });
      }
    } catch (err) {
      console.log("Error in API call:", err);
      setBillDates(null);
    }
  }

  const filesToBeUploadedBasedOnBillType = async (value) => {
    await sleep(300);
    setBillType(value);
    try {
    const categoriesV2 = JSON.parse(localStorage.getItem("categoriesV2") || "[]");
    const category = Array.isArray(categoriesV2)
      ? categoriesV2.find(cat => cat.category === value)
      : categoriesV2[value];
      if (category && category.dynamicBill) {
          const newBillTypeMapping = category.dynamicBill || [];
          setBillTypeMapping(newBillTypeMapping);
          initializeDocumentTypes(newBillTypeMapping);
      } else {
        setBillError("Bill uploads are not available at the moment. Please try again later.")
      }
    } catch (error) {
        console.log("Error in getting files to be uploaded:", error);
    }
  }

const addBillDocuements = async (documents, billDocType) => {
  let documentType = false;
  
  let fileError = { ...documentErrorMessage };
  fileError[billDocType] = [];
  
  
  for (var i = 0; i < documents.length; ++i) {
    if (!isSafeFilename(documents[i].name)) {
      fileError[billDocType] = "File name contains unsupported characters. Please use letters, numbers, or basic symbols only.";
      setErrorMessage(fileError);
      return;
    }
  }

  try {
    const isPdfSafe = await checkHarmfulPdfContent(documents);
    if (!isPdfSafe) {
      fileError[billDocType] = "Invalid or harmful file detected. Please upload valid PDF files only.";
      setErrorMessage(fileError);
      setIsUploading({ ...isUploading, [billDocType]: false });
      return;
    }
  } catch (error) {
    fileError[billDocType] = "Error validating PDF content. Please try again.";
    setErrorMessage(fileError);
    setIsUploading({ ...isUploading, [billDocType]: false });
    return;
  }
  
  let tempObjUploading = { ...isUploading };
  tempObjUploading[billDocType] = 1;
  setIsUploading(tempObjUploading);
  
  const currentDocCount = (billDocuments[billDocType] || []).length;
  if (currentDocCount === 0) {
    previousSize = 0;
    documentSize = 0;

    for (var i = 0; i < documents.length; ++i) {
      documentSize += documents[i].size / 1000;
      if (
        !(
          (documents[i].type === "application/pdf") |
          (documents[i].type === "image/png") |
          (documents[i].type === "image/jpg") |
          (documents[i].type === "image/jpeg")
        )
      ) {
        documentType = true;
      }
    }
  } else {
    previousSize = documentSize;
    for (var i = 0; i < documents.length; ++i) {
      documentSize += documents[i].size / 1000;
      if (
        !(
          (documents[i].type === "application/pdf") |
          (documents[i].type === "image/png") |
          (documents[i].type === "image/jpg") |
          (documents[i].type === "image/jpeg")
        )
      ) {
        documentType = true;
      }
    }
  }

  if (!documents) {
    fileError[billDocType] = "Please upload bill documents";
    documentSize = 0;
    tempObjUploading[billDocType] = 0;
    setIsUploading(tempObjUploading);
    setErrorMessage(fileError);
    return;
  } else if (documentSize > 52428800) {
    fileError[billDocType] = "File Size is beyond 50MB";
    documentSize = previousSize;
    tempObjUploading[billDocType] = 0;
    setIsUploading(tempObjUploading);
    setErrorMessage(fileError);
    return;
  } else if (documentType) {
    fileError[billDocType] = "Upload Only Image or PDF";
    documentSize = previousSize;
    tempObjUploading[billDocType] = 0;
    setIsUploading(tempObjUploading);
    setErrorMessage(fileError);
    return;
  } else {
    let res = await uploadClaimDocsToS3(documents, billDocType);
    if (res === "Token_Expired") {
      fileError[billDocType] = "Session expired please login again";
      documentSize = previousSize;
      tempObjUploading[billDocType] = 0;
      setIsUploading(tempObjUploading);
      setErrorMessage(fileError);
      return;
    } else if (res === "failure") {
      fileError[billDocType] = "Something went wrong please try again";
      documentSize = previousSize;
      tempObjUploading[billDocType] = 0;
      setIsUploading(tempObjUploading);
      setErrorMessage(fileError);
      return;
    } else if (res === "success") {
      const existingDocs = billDocuments[billDocType] || [];
      const newDocsForType = [...existingDocs, ...documents];

      const newFiles = JSON.parse(JSON.stringify(files));

      const billFiles = [];
      for (var i = 0; i < newDocsForType.length; ++i) {
        billFiles.push(newDocsForType[i].name); 
      }
      newFiles[billDocType] = billFiles;

      const newBillDocs = { ...billDocuments };
      newBillDocs[billDocType] = newDocsForType;

      setBillDocuments(newBillDocs);
      setFiles(newFiles);
      tempObjUploading[billDocType] = 0;
      setIsUploading(tempObjUploading);
      fileError[billDocType] = [];
      setErrorMessage(fileError);
      setTemp(!temp);
      return; 
    }
  }
  

  setErrorMessage(fileError);
  setTemp(!temp);
};


const deleteSelectedFile = async (index, billDocType) => {
    const currentDocs = billDocuments[billDocType] || [];
    const currentFileNames = files[billDocType] || [];
    const currentUploadedFiles = uploadedBillDocuments[billDocType] || [];
    const currentFileObjects = billsObjFileObjects[billDocType] || [];
    
    if (currentDocs[index]) {
      documentSize -= currentDocs[index].size / 1000;
      if (documentSize < 0) {
        documentSize = 0;
      }
    }
    
    const newDocsForType = currentDocs.filter((_, idx) => idx !== index);
    const newFileNamesForType = currentFileNames.filter((_, idx) => idx !== index);
    const newUploadedForType = currentUploadedFiles.filter((_, idx) => idx !== index);
    const newFileObjectsForType = currentFileObjects.filter((_, idx) => idx !== index);
    
    const newBillDocs = { ...billDocuments };
    const newFiles = { ...files };
    const newUploadedFiles = { ...uploadedBillDocuments };
    const newFileObjects = { ...billsObjFileObjects };
    
    newBillDocs[billDocType] = newDocsForType;
    newFiles[billDocType] = newFileNamesForType;
    newUploadedFiles[billDocType] = newUploadedForType;
    newFileObjects[billDocType] = newFileObjectsForType;
    
    let fileError = { ...documentErrorMessage };
    fileError[billDocType] = [];
    
    if (fileInputRefs.current[billDocType]) {
      fileInputRefs.current[billDocType].value = "";
    }
    
    setBillDocuments(newBillDocs);
    setFiles(newFiles);
    setUploadBillDocuments(newUploadedFiles);
    setBillsObjFileObjects(newFileObjects);
    setErrorMessage(fileError);
    
    billDocs = newBillDocs;
    
    setTemp(!temp);
  };

  const isBillsSelected = (formValues) => {
    const currentEntityId = Number(localStorage.getItem(LocalStorageKeys.CURRENT_PM_ENTITY_ID));
    const isPrescriptionQuestionEntity = 
      (billType === PRESCRIBED_PHARMACY_CONTRACT || billType === PHARMACY_CONTRACT) &&
      PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(currentEntityId);
    
    let cnt = 0;
    let requiredDocCount = 0;
    
    billTypeMapping.forEach((row) => {
      const isPrescriptionOptional = 
        row === DocumentType.PRESCRIPTION &&
        isPrescriptionQuestionEntity;
      
      if (isPrescriptionOptional) {
        return;
      }
      
      requiredDocCount += 1;
      
      if (billDocuments[row]?.length > 0) {
        cnt += 1;
      }
    });
    
    return !(cnt === requiredDocCount);
  };

  const optionalFieldPresent = useMemo(
    () =>
      hasOptionalField(props.billDetails.category, billDetailsFormConstants),
    [props.billDetails.category,props?.entityId]
  );

  const treatmentType = props.billDetails.additionals?.treatmentType;
  const illnessType = props.billDetails.additionals?.illnessType;
  const treatmentTypes = billDetailsFormConstants.dropDown.treatmentType[
    props.billDetails.category
  ]?.map((item) => item.value);
  const illnessTypes = (
    billDetailsFormConstants.dropDown.illnessType[props.billDetails.category]
      ? billDetailsFormConstants.dropDown.illnessType[
          props.billDetails.category
        ]
      : props.billDetails.category ===
        EMERGENCY_PATHOLOGY_CONTRACT
      ? [
          {
            label: "Emergency Pathology",
            value: "Emergency Pathology",
          },
          {
            label: "Non serviceable Pathology",
            value: "Non serviceable Pathology",
          },
        ]
      : billDetailsFormConstants.dropDown.illnessType["default"]
  )?.map((item) => item.value);

  const categories = useMemo(() => {
    // Map patient name to relation label
    let relationLabel = SELF;
    
    if (props.patientName) {
      try {
        // Use localStorage instead of sessionStorage so data persists when user directly opens IR flow
        const usersData = localStorage.getItem(USERS);
        if (usersData) {
          const users = JSON.parse(usersData);
          const beneficiary = users.benefs?.find(
            (user) => user.name === props.patientName
          );
          if (beneficiary) {
            relationLabel = beneficiary.relationName || beneficiary.relation || beneficiary.relation_label || "Self";
          }
        }
      } catch (error) {
        console.error(ERROR_MAPPING_PATIENT_NAME_TO_RELATION, error);
      }
    }
    
    return getBillCategories(relationLabel);
  }, [props.patientName]);
  const isTreatmentRequired = isFieldRequiredUtil(
    "treatmentType",
    props.billDetails.category,
    billDetailsFormConstants
  );
  const isIllnessRequired = isFieldRequiredUtil(
    "illnessType",
    props.billDetails.category,
    billDetailsFormConstants
  );

  const bannerRedirectionAndLogEvent = (url, page, serviceName) => {
    try {
      window.open(url);
    } catch (error) {
      return;
    }
  };
   const bannerClickHandler = handleBannerClick(
    token,
    props.accessToken
  )(bannerRedirectionAndLogEvent);

    const isMobileView = useMemo(() => {
    return isMobile(window.innerWidth);
  }, [window.innerWidth]);

   const viewFile = async (url) => {
      if (isWebView()) {
        let request = {
          fileUrl: url,
        };
        try {
          await taskDeviceBridge.showFileViewer(request);
        } catch (error) {
          console.error(error);
        }
      } else {
        window.open(url, "_blank");
      }
    };
  
  return (
    <Container
      maxWidth="xl"
      sx={{
        padding: { xs: "16px", sm: "24px" },
        paddingBottom: { xs: "100px", sm: "24px" },
      }}
    >
      <Formik
        initialValues={{
          treatmentType: billDetailsFormConstants.contractBasedFields[
            "treatmentType"
          ].includes(props.billDetails.category)
            ? // For Health_Check and Dependents_Preventive_Health_Check_Up, show actual value directly
              props.billDetails.category === HEALTH_CHECK || 
              props.billDetails.category === DEPENDENTS_PREVENTIVE_HEALTH_CHECK_UP ||
              props.billDetails.category === VACCINATION
              ? treatmentType || undefined
              : // For other categories with dropdown
                treatmentTypes && treatmentTypes.includes(treatmentType)
                ? treatmentType
                : isTreatmentRequired
                ? "others"
                : undefined
            : undefined,

          otherTreatmentType: billDetailsFormConstants.contractBasedFields[
            "treatmentType"
          ].includes(props.billDetails.category)
            ? // For Health_Check and Dependents_Preventive_Health_Check_Up, no otherTreatmentType needed
              props.billDetails.category === HEALTH_CHECK || 
              props.billDetails.category === DEPENDENTS_PREVENTIVE_HEALTH_CHECK_UP ||
              props.billDetails.category === VACCINATION
              ? null
              : // For other categories with dropdown
                treatmentTypes && treatmentTypes.includes(treatmentType)
                ? null
                : isTreatmentRequired
                ? treatmentType
                : null
            : undefined,

          illnessType: billDetailsFormConstants.contractBasedFields[
            "illnessType"
          ].includes(props.billDetails.category)
            ? illnessTypes && illnessTypes.includes(illnessType)
              ? illnessType
              : isIllnessRequired
              ? "others"
              : undefined
            : undefined,

          otherIllnessType: billDetailsFormConstants.contractBasedFields[
            "illnessType"
          ].includes(props.billDetails.category)
            ? illnessTypes && illnessTypes.includes(illnessType)
              ? null
              : isIllnessRequired
              ? illnessType
              : null
            : undefined,
          category: props.billDetails.category,
          billNumber: props.billDetails.billnumber,
          billDate: dateConverter(
            props.billDetails.billdate,
            TIMEZONES.INDIA,
            "default"
          ),
          billAmount: props.billDetails.billamount,
          pincode: props.billDetails.pincode,
          doctorRegisteredNumber: props.billDetails.doctorregisterednumber,
          doctorName: props.billDetails.doctorname,
          centerName: props.billDetails.hospitalname,
          centerAddress: props.billDetails.centreaddress,
          doctorSpeciality: props.billDetails.speciality,
          hasPrescription: props.billDetails.additionals?.hasPrescription || null,
          prescriptionReason: props.billDetails.additionals?.prescriptionReason || null,
        }}
        ref={formRef}
        onSubmit={async (values) => {
          let res = await updateBillDetails(values);
          if (res === "success") {
            setApiFailure();
            trackEvent.resubmitBillSaveClick({
              screenName: ScreenName.INFORMATION_REQUIRED,
              claim_id: props.billDetails.claimid,
              bill_id: props.billDetails.id,
            });
            submitBillDetails();
          } else if (res === "failure") {
            setApiFailure("Failed to upload try again");
          } else if (res === "Token_Expired") {
            setApiFailure("Session expired please login again");
          }
        }}
      >
        {({ isSubmitting, values, errors, setFieldValue }) => (
          <Form autoComplete="off">
            <Grid
              container
              spacing={3}
              sx={{ marginTop: isMobileView ? "25px" : "" }}
            >
              <Grid
                item
                xs={12}
                lg={6}
                sx={
                  !isMobileView
                    ? {
                        minHeight: "calc(100vh - 100px)",
                        overflowY: "auto",
                        paddingRight: "20px",
                      }
                    : {}
                }
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "18px", md: "22px" },
                    marginBottom: 2,
                    color: "#252D38",
                  }}
                >
                  Bill Type
                </Typography>
                <Select
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "100%",
                      borderRadius: "16px",
                    },
                  }}
                  id="category"
                  name="category"
                  label="Bill Type *"
                  onSelect={(event) => {
                    filesToBeUploadedBasedOnBillType(event);
                  }}
                  options={categories}
                />

                <br />
                <br />

                {billType && (
                  <>
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "18px", md: "22px" },
                          marginBottom: 1,
                          color: "#252D38",
                        }}
                      >
                        Bill Details
                      </Typography>

                      <p
                        style={{
                          fontSize: "14px",
                          color: "#47566A",
                          fontWeight: 400,
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <InfoOutlined sx={{ fontSize: "16px" }} /> Only fields
                        marked with * are mandatory
                      </p>

                      <BillDetails
                        billType={billType}
                        accessToken={props.accessToken}
                        editMode={true}
                        initialValues={values}
                        setFocusOnError={(fn) => (focusOnErrorRef.current = fn)}
                        fileInputRefs={fileInputRefs}
                        billDates={billDates}
                      />
                    </Box>
                    {!PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(Number(localStorage.getItem(LocalStorageKeys.CURRENT_PM_ENTITY_ID))) && (
                      <div className="Notes" style={{ marginTop: "24px" }}>
                        <h2
                          tabIndex={"0"}
                          style={{
                            fontSize: "18px",
                            fontWeight: 500,
                            color: "#252D38",
                          }}
                        >
                          Note:
                        </h2>
                        <ul
                          className="billNotes"
                          style={{
                            fontSize: "14px",
                            color: "#252D38",
                            fontWeight: 400,
                            listStyleType: "decimal",
                          }}
                        >
                          <li tabIndex={"0"}>
                            Bills should be in original and pre-numbered from the
                            doctor's official receipt book. Receipts must
                            mandatorily include pre-printed doctor's information
                            and receipt number. Blank document with the doctor's
                            signature/- stamp and letterhead bills are not
                            acceptable
                          </li>
                          <li tabIndex={"0"}>
                            A prescription must contain doctor's name, doctor's
                            registered number, doctor's degree, patient name, date
                            of appointment, signature and seal to be valid
                          </li>
                        </ul>
                      </div>
                    )}

                    {props.documentDetails &&
                      props.documentDetails.length > 0 && (
                        <Box sx={{ marginTop: "24px" }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "18px", md: "22px" },
                              marginBottom: 2,
                              color: "#252D38",
                            }}
                          >
                            Existing Documents
                          </Typography>
                          <Box
                            
                          >
                            {Object.keys(existingAllDocuments).length > 0 ? (
                              Object.keys(existingAllDocuments).map(
                                (billType, index) => {
                                  return existingAllDocuments[billType] &&
                                    existingAllDocuments[billType].length >
                                      0 ? (
                                    <Box key={index} sx={{ marginBottom: 2 }}>
                                      <Typography
                                        sx={{
                                          fontSize: "16px",
                                          fontWeight: 500,
                                          color: "#252D38",
                                          marginBottom: 1,
                                        }}
                                      >
                                        {capitalizeFirstLetter(billType)}
                                      </Typography>
                                      {existingAllDocuments[billType].map(
                                        (doc, idx) => (
                                          <Box
                                            key={idx}
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginBottom: "8px",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: "14px",
                                                color: "#252D38",
                                              }}
                                            >
                                              {capitalizeFirstLetter(billType)}{" "}
                                              {idx + 1}
                                            </Typography>

                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                marginBottom: "10px",
                                              }}
                                              onClick={() => viewFile(doc)}
                                            >
                                              <img
                                                src={eyeIcon}
                                                alt="View Document"
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                              <span
                                                style={{
                                                  color: "#004FB6",
                                                  textDecoration: "none",
                                                  fontSize: "14px",
                                                  fontWeight: 500,
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {isMobileView
                                                  ? "View"
                                                  : "View Document"}
                                              </span>
                                            </div>
                                          </Box>
                                        )
                                      )}
                                    </Box>
                                  ) : null;
                                }
                              )
                            ) : (
                              <Typography
                                sx={{ fontSize: "14px", color: "#47566A" }}
                              >
                                No documents available
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      )}

                    <Box sx={{ marginTop: "24px" }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "18px", md: "22px" },
                          marginBottom: 1,
                          color: "#252D38",
                        }}
                      >
                        Re-upload Documents
                      </Typography>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#47566A",
                          fontWeight: 400,
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <InfoOutlined
                          sx={{ fontSize: "16px", color: "#1778F2" }}
                        />
                        Upload only jpg, png or pdf files. Size limit is 50MB
                      </p>

                      {billTypeMapping.map((row, index) => {
                        const hasUploadedFiles =
                          files[row] && files[row].length > 0;

                        return (
                          <Box key={index} sx={{ marginBottom: "16px" }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "16px 0",
                                borderBottom: "1px solid #E5E7EB",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: 400,
                                  color: "#252D38",
                                }}
                              >
                                {row === DocumentType.PRESCRIPTION &&
                                props.billDetails.category === VACCINATION_CONTRACT &&
                                PRESCRIPTION_QUESTION_ENTITY_ID_LIST.includes(
                                  Number(localStorage.getItem(LocalStorageKeys.CURRENT_PM_ENTITY_ID))
                                )
                                  ? VACCINATION_LABEL
                                  : row.replace(/_/g, " ")}(s)
                              </Typography>

                              <input
                                ref={(el) =>
                                  (fileInputRefs.current[
                                    billTypeMapping[index]
                                  ] = el)
                                }
                                style={{ display: "none" }}
                                disabled={isUploading[row]}
                                name="files"
                                type="file"
                                id={`file-${row}`}
                                multiple
                                accept="image/jpeg,image/png,application/pdf"
                                onChange={async (e) => {
                                  await addBillDocuements(
                                    e.target.files,
                                    billTypeMapping[index]
                                  );
                                }}
                                onClick={(event) => {
                                  event.target.value = null;
                                }}
                              />

                              <Button
                                variant="outlined"
                                disabled={isUploading[row]}
                                startIcon={
                                  isUploading[row] ? (
                                    <CircularProgress size="1rem" />
                                  ) : (
                                    <Box
                                      component="span"
                                      sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        color: "#0066DC",
                                      }}
                                    >
                                      <img
                                        src={UploadIcons}
                                        alt="uploadIcon"
                                        style={{
                                          width: "17px",
                                          height: "17px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Box>
                                  )
                                }
                                onClick={() => {
                                  fileInputRefs.current[
                                    billTypeMapping[index]
                                  ]?.click();
                                }}
                                sx={{
                                  borderColor: "#72B3FF",
                                  color: "#0066DC",
                                  borderRadius: "8px",
                                  padding: "8px 16px",
                                  textTransform: "none",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  minWidth: "100px",
                                  "&:hover": {
                                    borderColor: "#0052B4",
                                    backgroundColor: "#F0F7FF",
                                  },
                                  "&:disabled": {
                                    borderColor: "#BFC8D2",
                                    color: "#8A99AD",
                                  },
                                }}
                              >
                                {isUploading[row] ? "Uploading..." : "Upload"}
                              </Button>
                            </Box>

                            {hasUploadedFiles && (
                              <UploadedFilesPreview
                                files={files[row]}
                                billsObjFileObjects={billsObjFileObjects[row]}
                                deleteSelectedFile={(index) =>
                                  deleteSelectedFile(index, row)
                                }
                                onPreviewClick={setPreviewModal}
                                isMobileView={isMobileView}
                              />
                            )}
                        
                            {documentErrorMessage[row] &&
                              documentErrorMessage[row].length > 0 && (
                                <Typography
                                  sx={{
                                    color: "#FC1721",
                                    fontSize: "14px",
                                    mt: 1,
                                    ml: 0,
                                  }}
                                >
                                  {Array.isArray(documentErrorMessage[row])
                                    ? documentErrorMessage[row].join(", ")
                                    : documentErrorMessage[row]}
                                </Typography>
                              )}
                          </Box>
                        );
                      })}
                    </Box>
                  </>
                )}

                {billError && (
                  <Typography
                    sx={{
                      color: "#FC1721",
                      fontSize: "14px",
                      mt: 2,
                    }}
                  >
                    {billError}
                  </Typography>
                )}

                {apiFailure && (
                  <Typography
                    sx={{
                      color: "#FC1721",
                      fontSize: "14px",
                      mt: 2,
                    }}
                  >
                    {apiFailure}
                  </Typography>
                )}
                <Box
                  sx={{
                    display: { xs: "none", lg: "block" },
                    marginTop: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Button
                        variant="outlined"
                        fullWidth
                        onClick={props.closeHandler}
                        disabled={isSubmitting}
                        sx={{
                          color: "#47566A",
                          borderRadius: "8px",
                          border: "1px solid #A4B0C0",
                          fontSize: "16px",
                          fontWeight: 500,
                          height: "48px",
                          backgroundColor: "#fff",
                          "&:hover": {
                            borderColor: "#A4B0C0",
                            backgroundColor: "#fff",
                          },
                        }}
                      >
                        Close
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        fullWidth
                        type="submit"
                        disabled={isBillsSelected(values) || isSubmitting}
                        startIcon={
                          isSubmitting ? <CircularProgress size="1rem" /> : null
                        }
                        sx={{
                          borderRadius: "8px",
                          fontSize: "16px",
                          fontWeight: 500,
                          color: "#fff",
                          height: "48px",
                          backgroundColor: "#0066DC",
                          "&:disabled": {
                            backgroundColor: "#DBE0E6",
                            color: "#8A99AD",
                            border: "1px solid #BFC8D2",
                          },
                        }}
                      >
                        {isSubmitting ? "Processing" : "Save"}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                lg={6}
                sx={{
                  display: { xs: "none", lg: "block" },
                  position: "sticky",
                  top: "100px",
                  alignSelf: "flex-start",
                  maxHeight: "calc(100vh - 250px)",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "400px",
                    margin: "0 auto",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                  }}
                >
                  <Carousel
                    itemClassnames={"bannerImg"}
                    pageId={pageConfigurationPageIDs.CREATE_CLAIM_PAGE}
                    carouselId={
                      pageConfigurationCarouselIDs.REIM_CREATE_CLAIM_CAROUSEL
                    }
                    bannerOnClick={bannerClickHandler}
                    slidesToShow={1}
                  />
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                display: { xs: "block", lg: "none" },
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "#fff",
                borderTop: "1px solid #E5E7EB",
                padding: "16px",
                zIndex: 1000,
                boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Container maxWidth="xl">
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      fullWidth
                      onClick={props.closeHandler}
                      disabled={isSubmitting}
                      sx={{
                        color: "#47566A",
                        borderRadius: "8px",
                        border: "1px solid #A4B0C0",
                        fontSize: "16px",
                        fontWeight: 500,
                        height: "42px",
                        backgroundColor: "#fff",
                        "&:hover": {
                          borderColor: "#A4B0C0",
                          backgroundColor: "#fff",
                        },
                      }}
                    >
                      Close
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      fullWidth
                      type="submit"
                      disabled={isBillsSelected(values) || isSubmitting}
                      startIcon={
                        isSubmitting ? <CircularProgress size="1rem" /> : null
                      }
                      sx={{
                        borderRadius: "8px",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#fff",
                        height: "42px",
                        backgroundColor: "#0066DC",
                        "&:disabled": {
                          backgroundColor: "#DBE0E6",
                          color: "#8A99AD",
                          border: "1px solid #BFC8D2",
                        },
                      }}
                    >
                      {isSubmitting ? "Processing" : "Save"}
                    </Button>
                  </Grid>
                </Grid>
              </Container>
            </Box>
            <Box
              sx={{ display: { xs: "block", lg: "none" }, height: "80px" }}
            />
          </Form>
        )}
      </Formik>

      <FilePreviewDialog
        previewModal={previewModal}
        onClose={() => {
          setPreviewModal({
            open: false,
            url: null,
            isPdf: false,
            name: "",
            fileObject: null,
          });
          setPageNumber(1);
          setNumPages(null);
        }}
        onDocumentLoadSuccess={onDocumentLoadSuccess}
        numPages={numPages}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
    </Container>
  );
}
